import * as actions from '../actions';
import {
  NUMBER_OF_DAYS_IN_A_YEAR,
  DEFAULT_CIGS_IN_A_PACK,
} from '../appConstants';

export default function createCalculatorReducer({ initialState } = {}) {
  return (state = initialState, action) => {
    switch (action.type) {
      case actions.CALCULATE_SAVINGS:
        const {
          price_per_pack,
          cigarettes_per_day,
        } = action.calculatorFormData;
        const cigarettesSmokedPerYear =
          cigarettes_per_day * NUMBER_OF_DAYS_IN_A_YEAR;
        const cigarettePacksSmokedPerYear =
          cigarettesSmokedPerYear / DEFAULT_CIGS_IN_A_PACK;
        const totalSpendingsOnCigarettes =
          cigarettePacksSmokedPerYear * price_per_pack;
        const totalSpendingsOnJuul =
          cigarettePacksSmokedPerYear * state.podPackPrice;
        const totalSavings = totalSpendingsOnCigarettes - totalSpendingsOnJuul;
        return {
          ...state,
          annualAmountSavings: Math.max(totalSavings, 0),
        };
      default:
        return state;
    }
  };
}
